import { render, staticRenderFns } from "./headerbar.vue?vue&type=template&id=0bc910d8&scoped=true&"
import script from "./headerbar.vue?vue&type=script&lang=js&"
export * from "./headerbar.vue?vue&type=script&lang=js&"
import style0 from "./headerbar.vue?vue&type=style&index=0&id=0bc910d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc910d8",
  null
  
)

export default component.exports